import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import PrepareDataTable from "./PrepareDataTable";
import { AdminListContainer, Title } from "./AdminList.styled";
import AddEditAdmin from "../AddEditAdmin";
import "./AdminList.scss";

/**
 * Specific Conditions List,
 * Path - /general/specificConditions
 * @see See [specific conditions Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3089104900/Administration+-+Quotes+specific+conditions)
 * @component
 */
const AdminList = (props) => {
  const { t, columnList, countries } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [isAddAdminPopupVisible, setAddAdminPopupVisible] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const createNewAdmin = () => {
    setAddAdminPopupVisible(true);
  };
  const closeAdminCreationPopup = () => {
    setAddAdminPopupVisible(false);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <AdminListContainer className="admins-list">
      <Title>{t("ADMINISTRATION_ADMINS_TITLE")}</Title>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        columnList={columnList}
        updateRefeshStatus={updateRefeshStatus}
        createNewSpecificCondition={createNewAdmin}
        countries={countries}
      />
      {isAddAdminPopupVisible && (
        <AddEditAdmin
          title={t("ADMIN_NEW_TITLE")}
          onClose={closeAdminCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </AdminListContainer>
  );
};

AdminList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
};

AdminList.defaultProps = {
  columnList: [],
};

export default withTranslation()(AdminList);
